import { ACTIVE_INITIATIVES, BUD } from "../../data/content";
import { SectionHeading, StatusBadge } from "../common";
import { BudCard } from "../BudCard";
import { Reveal } from "../Reveal";

export const ActiveDevelopment = () => (
    <section className="py-24 md:py-32 border-b border-thg-border" data-testid="active-development-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <SectionHeading
                index="03"
                overline="Active Development"
                title="In progress, labeled honestly."
                text="Selected initiatives currently being built or explored. None of these are presented as finished businesses."
            />
            <div className="mt-16 border-t border-thg-border">
                {ACTIVE_INITIATIVES.filter((item) => item.name !== BUD.name).map((item, i) => (
                    <Reveal
                        key={item.name}
                        delay={i * 0.08}
                        className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 items-start py-8 border-b border-thg-border"
                        data-testid={`active-initiative-${i}`}
                    >
                        <div className="md:col-span-4">
                            <h3 className="font-display text-xl md:text-2xl font-medium text-white">{item.name}</h3>
                            <p className="mt-1 text-xs tracking-[0.15em] uppercase text-thg-tertiary">{item.division}</p>
                        </div>
                        <p className="md:col-span-6 text-sm leading-relaxed text-thg-secondary">{item.summary}</p>
                        <div className="md:col-span-2 md:text-right">
                            <StatusBadge>{item.status}</StatusBadge>
                        </div>
                    </Reveal>
                ))}
            </div>
            {/* Bud — pictured, linked evidence card (shared component, cannot drift) */}
            <Reveal delay={0.1} className="mt-8 max-w-2xl">
                <BudCard />
            </Reveal>
        </div>
    </section>
);
